import { Sport } from '@/constants';
import type { DataTableHeader } from '@/types/vuetify';
import { createLivePageHeadersBasketball } from './LivePageHeadersBasketball';
import { createLivePageHeadersFootball } from './LivePageHeadersFootball';

export function createLivePageHeaders(sportId: number): DataTableHeader[] {
    if (sportId === Sport.Basketball) {
        return createLivePageHeadersBasketball();
    }
    return createLivePageHeadersFootball();
}
